import {Component} from '@angular/core';

@Component({
  selector: 'app-question-and-answer',
  templateUrl: './question-and-answer.component.html',
  styleUrls: ['./question-and-answer.component.scss']
})
export class QuestionAndAnswerComponent {

  faqs: FAQ[] = [
    {
      question: 'Application phase', answer: '', isCollapsed: false, faq: [
        {
          question: 'Why do we have to draw budgets in different currencies?',
          answer: 'The NHC operates with different currencies based among others on the sources of its funding and to minimize currency exchange losses.',
          isCollapsed: true
        },
        {
          question: 'What is the meaning/difference between an output and an activity?',
          answer: 'An output is the direct, measurable result of an activity. If your activity is research, documentation and report writing, then the output from this activity is the actual report that you write. If your activity is carrying out an advocacy campaign then the outputs of this activity are your social media products, leaflets, posters etc. that are produced as a result of the activity.',
          isCollapsed: true
        },
        {
          question: 'Are we allowed to ask for an overhead?',
          answer: 'Yes.',
          isCollapsed: true
        },
        {
          question: 'In the organization profile – what is the corresponding bank and is it must to provide the details of it?',
          answer: 'If you are not aware of a corresponding bank for your organization, you probably do not have one and you can leave this field blank.',
          isCollapsed: true
        }
      ]
    },
    {
      question: 'Implementation phase (including reporting)',
      answer: '',
      isCollapsed: true,
      faq: [
        {
          question: "How much relocation of funds from one line to another is allowed within approved budget?",
          answer: "As a general rule there is a 10% allowance  (of the entire amount) for reallocation.",
          isCollapsed: true
        },
        {
          question: "Do we have to submit all financial documentation during mid-term reporting?",
          answer: "No. You only need to provide a financial overview of costs (without financial documentation) along with a narrative status, provided that your project is more than 6 months long. Financial documentation must be submitted as part of the final report.",
          isCollapsed: true
        },
        {
          question: "What if it is impossible to receive financial documents for some of the expenses? ",
          answer: "Contact your grant manager at the NHC and agree on how to proceed.",
          isCollapsed: true
        },
        {
          question: "Should we put the NHC logo in our printed materials\\videos\\etc.? ",
          answer: "As a general rule, yes. In cases where providing the NHC logo is sensitive or risky, you should not do this.",
          isCollapsed: true
        },
        {
          question: "Where can we write a detailed description of each activity and information about its implementation?",
          answer: "You can do this in the final report form.",
          isCollapsed: true
        },
        {
          question: "If the planned activity can no longer be implemented due to significant changes in the country-situation, how should we proceed? And what to do with the approved budget?"
          ,
          answer: "All significant deviations from approved plans must be reported to your grant manager immediately. Significant deviations include: changes to project’s sources of income, changes to activities and implementation plans that will have an effect on the results achievement, changes to the budget. In cases where activities cannot be carried out, discuss with your grant manager at the NHC what the best use of the funds can be. Please make sure you check also the Terms and conditions of your grant."
          ,
          isCollapsed: true
        }, {
          question: "What to do if the partner organization officially ceases to exist (for example due to prosecution or liquidation) - but their employees continue working (outside of the country)?",
          answer: "Contact your grant manager at the NHC immediately.",
          isCollapsed: true
        }, {
          question: "One of the activities was postponed and will be implemented after the status report submission deadline, can you extend the deadline so that we can report on the activity?",
          answer: "No. The postponed activity should be reported as “postponed” in the status report and reported on its implementation in the subsequent report.",
          isCollapsed: true
        }
      ]
    },
    {
      question: 'End of project phase',
      answer: '',
      isCollapsed: true,
      faq: [
        {
          question: "How much time is there to submit the financial report after the end of the project?",
          answer: "For projects lasting up to 12 months, the deadline for submitting the final narrative and financial report is 1 month from the end date of the project.",
          isCollapsed: true
        },
        {
          question: "There’s some small sum of money left after the end of the project. How can grantees use it? ",
          answer: "Please check the Terms and Conditions of your grant. If in doubt, contact your grant manager at the NHC.",
          isCollapsed: true
        },
        {
          question: "What exchange rate should one use if the currency of the project and currency of the payments are not the same?",
          answer: "Use the exchange rate applicable for the day you receive the funds on your organization’s account. Your back receipt should include information about the amount received in the currency it was sent and the amount converted into your account.",
          isCollapsed: true
        },
        {
          question: "How to report about each activity and its implementation (in details)?",
          answer: "To report on your project, please fill out the required report form applicable for your project. If there are specific achievements/stories you want to convey, the forms include specific filed for this purpose."
          , isCollapsed: true
        }
      ]
    }
  ];

  toggleCollapse(faq: FAQ) {
    faq.isCollapsed = !faq.isCollapsed;
  }


}

interface FAQ {
  question: string;
  answer: string;
  isCollapsed: boolean;
  faq?: FAQ[];
}
